import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { useConfigStore } from './config'

export type BookingStep = 'reservation' | 'client-info' | 'warranty'

export type Step = {
  key: string
  name: string
  value: BookingStep
  isDone?: boolean
}

export const useStepsStore = defineStore('steps', () => {
  const { t } = useI18n()
  const configStore = useConfigStore()

  const currentStep = ref<BookingStep>('reservation')

  const baseSteps: Step[] = [
    { key: '0', value: 'reservation', name: t('steps.reservation') },
    { key: '1', value: 'client-info', name: t('steps.client-info') },
    { key: '2', value: 'warranty', name: t('steps.warranty') }
  ]

  const currentStepKey = computed(
    () => baseSteps.find(step => step.value === currentStep.value)?.key || '0'
  )

  const currentStepIndex = computed(() =>
    baseSteps.findIndex(step => step.value === currentStep.value)
  )

  const steps = computed<Step[]>(() => {
    const activeSteps = baseSteps.filter(
      step => !(step.value === 'warranty' && !configStore.hasWarranty)
    )

    return activeSteps.map(step => {
      const stepIndex = baseSteps.findIndex(s => s.value === step.value)
      return {
        ...step,
        isDone: stepIndex < currentStepIndex.value
      }
    })
  })

  function setStep(step: BookingStep) {
    currentStep.value = step
  }

  return {
    currentStep,
    currentStepKey,
    currentStepIndex,
    steps,
    setStep
  }
})
